import React, { FC } from 'react';
import { Text } from 'react-native';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';

interface JobDetailsNCFilePerformanceUtilizationProps {}

const JobDetailsNCFilePerformanceUtilization: FC<JobDetailsNCFilePerformanceUtilizationProps> = () => {
  return (
    <DetailsPageWrapper title="Job">
      <Text>JobDetailsNCFilePerformanceUtilization</Text>
    </DetailsPageWrapper>
  );
};

export { JobDetailsNCFilePerformanceUtilization };
